var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-08-30
 * @brief EHP ManageMent - userManageMent 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import { useAsync } from "react-async";
// recoil && state
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useNavigate } from "react-router-dom";
import EhpPagination from "../../common/pagination/EhpPagination";
import { useTrans } from "../../../utils/langs/useTrans";
/**
 * @brief EHP ManageMent - userManageMent 개발 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function UserApproval(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //화면 이동
    const navigate = useNavigate();
    const t = useTrans();
    //props
    const setParentPopWin = props.setPopWin;
    const roleDto = [
        { id: "0", value: "", fname: "전체", /* active: false */ },
        { id: "1", value: CONST.USERROLE_ADMIN, fname: "Admin", /* active: false */ },
        { id: "2", value: CONST.USERROLE_ENGINEER, fname: "Engineer", /* active: false */ },
        { id: "3", value: CONST.USERROLE_USER, fname: "User", /* active: false */ },
        { id: "4", value: CONST.USERROLE_NONE, fname: "Non-User", /* active: false */ },
    ];
    //Approval
    const [toggle, setToggle] = useState(false);
    const [load, setload] = useState(false);
    const [item, setitem] = useState(null);
    const [approvalNo, setApprovalNo] = useState("");
    const [reload, setReload] = useState(false);
    const [userDisplayDone, setUserDisplayDone] = useState(false);
    const [userDisplayCompanion, setUserDisplayCompanion] = useState(false);
    const [userLoad, setUserLoad] = useState(false);
    //ApprovalPop
    const [companyItem, setCompanyItem] = useState([]);
    const [zoneItem, setZoneItem] = useState([]);
    const [addListResult, setAddListResult] = useState([]);
    const [checked, setChecked] = useState(false);
    const [userType, setUserType] = useState("");
    const [companionTxt, setCompanionTxt] = useState("");
    const [errorList, setErrorList] = useState([]);
    //ApprovalPop - site addPop
    const [companyAdd, setCompanyAdd] = useState([]);
    const [zoneAdd, setZoneAdd] = useState([]);
    const [addList, setAddList] = useState([]);
    //
    const [totalCount, setTotalCount] = useState([]);
    //
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    let appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    let appPath2 = 'page=' + 0 + '&size=' + pageInfo.totalElements;
    //
    const [userDto, setUserDto] = useState([]);
    // 신규 가입자 List
    const { data: data, error, isLoading, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/users/approval?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + userLoad + load
    });
    useEffect(() => {
        // error page 이동
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setUserDto(data.body);
                setPageInfo(data.data.page);
            }
        }
    }, [data]);
    const { data: totaldata, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/users/approval?${appPath2}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath2 + reload + userLoad + load
    });
    useEffect(() => {
        // error page 이동
        if (totaldata) {
            if (totaldata.codeNum == CONST.API_200) {
                setTotalCount(totaldata.body);
            }
        }
    }, [totaldata]);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function toggles(e) {
        if (toggle === false) {
            setToggle(true);
        }
        else {
            setToggle(false);
        }
    }
    // 신규 가입자 승인 요청 API
    function approvalPop(e, list) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.jsopen_Popup(e);
            setitem(list);
            if (list.approval == 2) {
                setUserDisplayCompanion(false);
                setUserDisplayDone(true);
            }
            else {
                setUserDisplayCompanion(false);
            }
        });
    }
    // <!-- 신규 가입 요청 팝업 --> 
    useEffect(() => {
        if (CUTIL.isnull(item))
            return;
        setParentPopWin("pop-userjoin-ok", React.createElement(RequestApproval, { htmlHeader: (item) && React.createElement("h1", null, (item.enabled == true) ? "신규 가입자 _ " + item.userName : "신규 가입자 _ " + item.userName + "(미인증)"), htmlHeaderBtn: (item) && React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => close(e) },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), userInfo: userInfo, item: item, approvalNo: approvalNo, addListResult: addListResult, checked: checked, setChecked: setChecked, userType: userType, companionTxt: companionTxt, setCompanionTxt: setCompanionTxt, errorList: errorList, reload: reload, setReload: setReload, setload: setload, userDisplayDone: userDisplayDone, setUserDisplayDone: setUserDisplayDone, userDisplayCompanion: userDisplayCompanion, setUserDisplayCompanion: setUserDisplayCompanion, roleDto: roleDto, 
            //
            companySelect: companySelect, approvalChang: approvalChang, listDelete: listDelete, usertypeSelect: usertypeSelect, userApprovalDone: userApprovalDone, onCompanion: onCompanion, onDone: onDone }));
    });
    // <!-- 신규 가입자 정보 팝업 (웹,탭용 팝업) --> 
    useEffect(() => {
        setParentPopWin("pop-userjoin-info", React.createElement(SiteCeatePop, { htmlHeader: (item) && React.createElement("h1", null,
                "\uC2E0\uADDC \uAC00\uC785\uC790 _ ",
                item.userName), item: item, companyItem: companyItem, zoneItem: zoneItem, companyAdd: companyAdd, zoneAdd: zoneAdd, addLists: addLists, 
            //
            companyClick: companyClick, zoneClick: zoneClick, listAdd: listAdd, listDelete: listDelete, siteAdd: siteAdd }));
    });
    // 승인 API 
    function approvalChang(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/user/${list.userIdPk}/approval`,
                appQuery: {
                    approval: 2
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setApprovalNo(data.body.approval);
                    setReload(true);
                    setUserDisplayCompanion(false);
                    setUserDisplayDone(true);
                }
            }
        });
    }
    // 반려 display
    function onCompanion(e) {
        if (userDisplayCompanion === false) {
            setUserDisplayCompanion(true);
            setUserDisplayDone(false);
        }
        else if (item.enabled === false) {
            setUserDisplayCompanion(false);
        }
    }
    // 승인 선택
    function onDone(e) {
        if (userDisplayDone === false) {
            setUserDisplayDone(true);
            setUserDisplayCompanion(false);
            setCompanionTxt("");
        }
    }
    // 회사 API
    function companySelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: "/api/v2/product/companies",
                appQuery: {
                // language: apiLang,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCompanyItem(data.body);
                    var company = document.getElementById("company");
                    var companyhange = document.getElementById("company_change");
                    var zone = document.getElementById("zone");
                    var zoneChange = document.getElementById("zone_change");
                    company.click();
                    companyhange.classList.remove("hide");
                    companyhange.click();
                    companyhange.classList.add("hide");
                    zone.click();
                    zoneChange.classList.remove("hide");
                    zoneChange.click();
                    zoneChange.classList.add("hide");
                }
            }
        });
    }
    //회사 선택 시 사업장 API 연계까지
    function companyClick(e, company) {
        return __awaiter(this, void 0, void 0, function* () {
            if (company) {
                // 셀렉트 선택 시 data
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: "/api/v2/product/company/zones?companyId=" + company.companyId,
                    appQuery: {
                    // language: apiLang,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setZoneItem(data.body);
                        setCompanyAdd(company);
                        var zone = document.getElementById("zone");
                        var zoneChange = document.getElementById("zone_change");
                        zone.click();
                        zoneChange.classList.remove("hide");
                        zoneChange.click();
                        zoneChange.classList.add("hide");
                    }
                }
            }
        });
    }
    // 사업장 이벤트
    function zoneClick(e, zone) {
        setZoneAdd(zone);
    }
    //ApprovalPop - site addPop ListAdd
    function listAdd(e, companyAdd, zoneAdd, list) {
        var listVal = {
            userIdPk: list.userIdPk,
            companyId: companyAdd.companyId,
            companyName: companyAdd.companyName,
            zoneId: zoneAdd.zoneId,
            zoneName: zoneAdd.zoneName,
            address: zoneAdd.address,
            // url: URL.createObjectURL(file),
        };
        if (zoneAdd != "") {
            setAddList([...addList, listVal]);
        }
    }
    //ApprovalPop - site addPop ListDelete
    function listDelete(list) {
        setAddList(addList.filter(delList => delList.zoneId !== list.zoneId));
        setAddListResult(addListResult.filter(delList => delList.zoneId !== list.zoneId));
    }
    // siet 등록 이벤트
    function siteAdd(addLists) {
        return __awaiter(this, void 0, void 0, function* () {
            setAddListResult(addLists);
            const popcloes = document.getElementsByClassName("js-close");
            popcloes;
        });
    }
    // 사용자 타입
    function usertypeSelect(e) {
        setErrorList(errorList.filter((err) => (err.field !== "role")));
        setUserType(e.target.value);
        setChecked(true);
        if (e.target.value !== CONST.USERROLE_USER) {
            addListResult.length;
            setAddList([]);
            setAddListResult([]);
        }
    }
    // 승인 완료 
    function userApprovalDone(list, userType, addListResult) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/auth/user/${list.userIdPk}/roleusertree`,
                appQuery: {
                    role: userType,
                    usertree: addListResult.map((el) => ({
                        product: "zone",
                        productName: el.zoneName,
                        productParentId: el.companyId,
                        approval: 2,
                        isontree: true
                    }))
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("사용자 승인 요청이 완료되었습니다.");
                    setUserLoad(true);
                    var btnCommentClose_mng = document.getElementById("pop-userjoin-ok");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose_mng))
                        btnCommentClose_mng.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function close(e) {
        var btnCommentClose = document.getElementById("pop-userjoin-ok");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        /*
                var radioCheck = document.getElementById("rd0");
                radioCheck.click() */
        setUserType((item.role == 0) ? "" : item.role);
        setChecked(false);
        setErrorList([]);
        setAddList([]);
        setAddListResult([]);
    }
    const userList = (userDto == null) ? null : userDto;
    const approval = (totalCount == null) ? null : totalCount.filter((data) => (data.approval != 0) && (data.approval != 3)).length;
    // 중복제거 이벤트
    const addLists = addList.filter((arr, index, callback) => index === callback.findIndex(t => t.zoneId === arr.zoneId));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "page-top more__detail", onClick: (e) => toggles(e) },
            React.createElement("h2", null, "\uC2E0\uADDC \uAC00\uC785\uC790"),
            React.createElement("p", { className: "user-num" }, approval)),
        React.createElement("div", { className: `area__left_content detail__view ${(toggle) ? "on" : ""}` },
            React.createElement("div", { className: "tbl-list user-list hcal-vh-315" },
                React.createElement("table", { summary: "\uD68C\uC0AC,\uC774\uB984 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2E0\uADDC \uAC00\uC785\uC790 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC2E0\uADDC \uAC00\uC785\uC790 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" },
                                React.createElement("span", null, "\uD68C\uC0AC")),
                            React.createElement("th", { scope: "col", className: "txt-left" },
                                React.createElement("span", null, "\uC774\uB984")),
                            React.createElement("th", { scope: "col" },
                                React.createElement("span", null, " \uC2B9\uC778\uC694\uCCAD")))),
                    React.createElement("tbody", null,
                        (userList) && userList.filter((list) => (list.approval != 0) && (list.approval != 3)).map((list) => (React.createElement("tr", { key: list.userIdPk },
                            React.createElement("td", { className: `txt-left ${(list.enabled == false) && "icon-dot"} ${((list.enabled == false)) && "disabled"} ` }, list.companyName),
                            React.createElement("td", { className: `txt-left ${(list.enabled == false) && "icon-dot"} ${((list.enabled == false)) && "disabled"} pl-22` },
                                React.createElement("span", null, list.userName)),
                            React.createElement("td", null,
                                React.createElement("button", { type: "button", className: "bg-blue center js-open", "data-pop": "pop-userjoin-ok", onClick: (e) => approvalPop(e, list) },
                                    React.createElement("span", { "data-pop": "pop-userjoin-ok" }, "\uD655\uC778")))))),
                        (userList) && userList.filter((list) => (list.approval != 0) && (list.approval == 3)).map((list) => (React.createElement("tr", { key: list.userIdPk },
                            React.createElement("td", { className: "txt-left" }, list.companyName),
                            React.createElement("td", { className: "txt-left" }, list.userName),
                            React.createElement("td", null,
                                React.createElement("button", { type: "button", className: "bg-lightmoregray center" },
                                    React.createElement("span", null, "\uC2B9\uC778 \uC644\uB8CC"))))))))),
            (pageInfo) && React.createElement(EhpPagination, { componentName: "UserApproval", pageInfo: pageInfo, handleFunc: handleCurPage, dispLabel: t("LABEL.최근90일") }))));
}
export default UserApproval;
//신규 가입자요청 팝업
function RequestApproval(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const item = (props.item == null) ? null : props.item;
    const addListResultData = props.addListResultData;
    const companionTxt = props.companionTxt;
    const userType = props.userType;
    const addListResult = props.addListResult;
    const setUserDel = props.setUserDel;
    const reload = props.reload;
    const userApprovalDone = props.userApprovalDone;
    const setUserType = props.setUserType;
    const checked = props.checked;
    const setChecked = props.setChecked;
    const setUserTypeItme = props.setUserTypeItme;
    const userDisplayDone = props.userDisplayDone;
    const userDisplayCompanion = props.userDisplayCompanion;
    const onDone = props.onDone;
    const approvalChang = props.approvalChang;
    const onCompanion = props.onCompanion;
    const setload = props.setload;
    //
    const [list, setList] = useState(null);
    // user item API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/user/${item.userIdPk}`,
        userToken: userInfo.loginInfo.token,
        watch: item.userIdPk + reload
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setList(data.body);
            }
        }
    }, [data]);
    //
    // 반려 완료
    function userApprovalDel(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/user/${list.userIdPk}/approval`,
                appQuery: {
                    approval: 0,
                    deniedReason: companionTxt
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("메일 전송이 완료되었습니다.");
                    setload(true);
                    var btnCommentClose_mng = document.getElementById("pop-userjoin-ok");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose_mng))
                        btnCommentClose_mng.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        (list) &&
            React.createElement("div", { className: `popup__body ${(item.enabled === false) ? "alldisabled" : ""}` },
                React.createElement("div", { className: "left" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "E-mail (\uC544\uC774\uB514)"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp1", value: list.userId, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp2", value: list.userName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC5F0\uB77D\uCC98"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp3", value: list.phoneNumber, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uD68C\uC0AC"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp4", value: list.companyName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp5", value: list.zoneName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBD80\uC11C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp6", value: list.department, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC5C5\uC885"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp7", value: list.classification, disabled: true }))),
                        React.createElement("li", { className: "mt-45" },
                            React.createElement("p", { className: "tit star mt-8" }, "\uC2B9\uC778 \uC5EC\uBD80"),
                            React.createElement("div", { className: "btn__wrap" },
                                (list.approval == 2) && (item.enabled == true) &&
                                    React.createElement("button", { type: "button", className: (userDisplayDone) ? "bg-navy" : "", onClick: (e) => onDone(e) },
                                        React.createElement("span", null, "\uC2B9\uC778")),
                                (list.approval == 1) && (item.enabled == true) &&
                                    React.createElement("button", { type: "button", onClick: (e) => approvalChang(list) },
                                        React.createElement("span", null, "\uC2B9\uC778")),
                                React.createElement("button", { type: "button", className: (userDisplayCompanion) ? "bg-navy" : "", onClick: (e) => onCompanion(e) },
                                    React.createElement("span", null, "\uBC18\uB824")))))),
                React.createElement("div", { className: "right" },
                    React.createElement("ul", { className: "form__input" },
                        (userDisplayCompanion) &&
                            React.createElement(Companion, { companionTxt: props.companionTxt, setCompanionTxt: props.setCompanionTxt }),
                        (list.approval != 1 && userDisplayDone && item.enabled == true) &&
                            React.createElement(IsSavedApproval, { list: list, addListResult: props.addListResult, errorList: props.errorList, 
                                //
                                companySelect: props.companySelect, userType: props.userType, setUserType: setUserType, checked: checked, setChecked: setChecked, usertypeSelect: props.usertypeSelect, roleDto: props.roleDto, listDelete: props.listDelete, reload: props.reload, addListResultData: addListResultData, setUserDel: setUserDel, setUserTypeItme: setUserTypeItme })))),
        (list) &&
            React.createElement("div", { className: "popup__footer" }, (userDisplayCompanion && props.companionTxt) ?
                React.createElement("button", { type: "button", onClick: (e) => userApprovalDel(list) },
                    React.createElement("span", null, "\uC644\uB8CC"))
                : (userDisplayDone && list.approval == 2) ?
                    React.createElement("button", { type: "button", onClick: (e) => userApprovalDone(list, userType, addListResult) },
                        React.createElement("span", null, "\uC644\uB8CC"))
                    :
                        React.createElement("button", { type: "button", disabled: true },
                            React.createElement("span", null, "\uC644\uB8CC")))));
}
//신규 가입자 승인 
function IsSavedApproval(props) {
    const list = (props.list == null) ? null : props.list;
    const addListResult = (props.addListResult == null) ? null : props.addListResult;
    const checked = props.checked;
    const listDelete = props.listDelete;
    const roleDto = props.roleDto;
    const errorList = props.errorList;
    const userType = props.userType;
    //
    return (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            React.createElement("p", { className: "tit star question" },
                React.createElement("span", null, "\uC0AC\uC6A9\uC790 \uD0C0\uC785")),
            React.createElement("div", { className: "input__area" },
                React.createElement("div", { className: (errorList.filter(err => (err.field === "role")).length > 0) ? "radioBox input-error" : "radioBox" },
                    React.createElement("label", { id: "rd_" + roleDto[0].id, className: "hide" },
                        React.createElement("input", { type: "radio", id: "rd_" + roleDto[0].id, name: "rd", value: roleDto[0].value, checked: !checked, onChange: (e) => props.usertypeSelect(e) })),
                    roleDto.filter((type) => (type.id != 4) && (type.id != 0)).map((type) => (React.createElement("label", { id: "rd_" + type.id, key: type.id },
                        (list.enabled == false) ?
                            React.createElement("input", { type: "radio", disabled: true, id: "rd_" + type.id, name: "rd" })
                            :
                                React.createElement("input", { type: "radio", id: "rd_" + type.id, name: "rd", value: (type.value === userType) ? type.value : type.value, checked: (userType === type.value) ? true : false, onChange: (e) => props.usertypeSelect(e) }),
                        type.fname)))),
                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "role")).map((err) => err.msg)))),
        React.createElement("li", { className: "inline" },
            React.createElement("p", { className: "tit " }, "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D"),
            (userType == roleDto[3].value) ?
                React.createElement("button", { type: "button", className: "btn-basic js-open d-sm-none", "data-pop": "pop-userjoin-info", onClick: (e) => { CUTIL.jsopen_Popup(e), props.companySelect(e); } },
                    React.createElement("span", { "data-pop": "pop-userjoin-info" }, "\uCD94\uAC00"))
                :
                    React.createElement("button", { type: "button", className: "btn-basic", disabled: true },
                        React.createElement("span", null, "\uCD94\uAC00"))),
        React.createElement("li", { className: "mb-0" },
            React.createElement("div", { className: "tbl-list type2 mt-m10" },
                React.createElement("table", { summary: "No.,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Sites \uCD94\uAC00 \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD\uC790 \uC815\uBCF4 \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: {} })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "No."),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("th", { scope: "col", className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))),
                    React.createElement("tbody", null, (addListResult) && addListResult.map((list, idx) => (React.createElement("tr", { key: list.zoneId },
                        React.createElement("td", { className: "txt-left" }, ++idx),
                        React.createElement("td", { className: "txt-left" }, list.companyName),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("span", { className: "icon-navi" }, list.zoneName)),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn-delete-g", onClick: (e) => listDelete(list) },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))))))))))));
}
// 신규가입자- 반려
function Companion(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: "inline" },
            React.createElement("p", { className: "tit star" }, "\uBC18\uB824 \uC0AC\uC720 \uC785\uB825")),
        React.createElement("li", null,
            React.createElement("div", { className: "input__area w100p" },
                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694", value: props.companionTxt, onChange: (e) => props.setCompanionTxt(e.target.value) })))));
}
//신규 가입자 - site 등록
function SiteCeatePop(props) {
    //props
    const item = (props.item == null) ? null : props.item;
    const companyItems = (props.companyItem === null) ? null : props.companyItem;
    const zoneItems = (props.zoneItem === null) ? null : props.zoneItem;
    const addLists = (props.addLists === null) ? null : props.addLists;
    const addListResultData = props.addListResultData;
    //
    const companyAdd = props.companyAdd;
    const zoneAdd = props.zoneAdd;
    const addList = props.addList;
    const setAddList = props.setAddList;
    //
    const companyClick = props.companyClick;
    const zoneClick = props.zoneClick;
    const listAdd = props.listAdd;
    const listDelete = props.listDelete;
    const siteAdd = props.siteAdd;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body layout-vertical" },
            React.createElement("ul", { className: "form__input inline mb-24" },
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "company" },
                        React.createElement("span", { className: "star" }, "\uD68C\uC0AC")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "company", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", { className: "hmax-385" },
                                React.createElement("li", { id: "company_change", className: "option hide", onClick: (e) => companyClick(e, "") }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                companyItems.map((list) => (React.createElement("li", { key: list.companyId, className: "option", onClick: (e) => companyClick(e, list) }, list.companyName))))))),
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "company" },
                        React.createElement("span", { className: "star" }, "\uC0AC\uC5C5\uC7A5")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "zone", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", { className: "hmax-385" },
                                React.createElement("li", { id: "zone_change", className: "option hide", onClick: (e) => zoneClick(e, "") }, "\uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD574\uC8FC\uC138\uC694"),
                                zoneItems.map((list) => (React.createElement("li", { key: list.zoneId, className: "option", onClick: (e) => zoneClick(e, list) }, list.zoneName)))))),
                    React.createElement("button", { type: "button", className: "btn-basic ml-18", onClick: (e) => listAdd(e, companyAdd, zoneAdd, item) },
                        React.createElement("span", null, "\uCD94\uAC00")))),
            React.createElement("div", { className: "tbl-list type2" },
                React.createElement("table", { summary: "No.,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5\uBA85, \uC0AC\uC5C5\uC7A5 \uC8FC\uC18C, \uD56D\uBAA9\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2E0\uADDC \uAC00\uC785\uC790 \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC2E0\uADDC \uAC00\uC785\uC790 \uC815\uBCF4 \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: {} })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "No."),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("th", { scope: "col", className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))),
                    React.createElement("tbody", null, (addLists) && addLists.map((list, idx) => (React.createElement("tr", { key: list.zoneId },
                        React.createElement("td", { className: "txt-left" }, ++idx),
                        React.createElement("td", { className: "txt-left" }, list.companyName),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("span", { className: "icon-navi" }, list.zoneName)),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, list.address)),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn-delete-g", onClick: (e) => listDelete(list) },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C")))))))))),
        React.createElement("div", { className: "popup__footer right" },
            React.createElement("button", { type: "button", className: "js-close bg-linegray", onClick: (e) => closeBtn("pop-userjoin-info") },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "js-close", onClick: (e) => siteAdd(addLists) },
                React.createElement("span", null, "\uB4F1\uB85D")))));
}
function closeBtn(type) {
    var btnCommentClose = document.getElementById(type);
    var body = document.body;
    var dimm = body.querySelector(".dimm");
    if (!CUTIL.isnull(btnCommentClose))
        btnCommentClose.classList.add("hidden");
    if (!CUTIL.isnull(body))
        body.setAttribute("style", "overflow-y: hidden;");
    if (!CUTIL.isnull(dimm))
        dimm.setAttribute("style", "display: block; z-index: 30;");
}
